// @flow
import Projection from "./Projection";

const R = 6378137;
const MAX_LATITUDE = 85.0511287798;

export default class SphericalMercator extends Projection {

    project(lnglat) {
        const [lng, lat] = super.project(lnglat);
        const d = Math.PI / 180;
        const  max = MAX_LATITUDE;
        const  _lat = Math.max(Math.min(max, lat), -max);
        const  sin = Math.sin(_lat * d);
        return [  R * lng * d, R * Math.log((1 + sin) / (1 - sin)) / 2 ];
    }

    unproject(point) {
        const [x, y] = super.unproject(point);
        const d = 180 / Math.PI;
        return [x * d / R, (2 * Math.atan(Math.exp(y / R)) - (Math.PI / 2)) * d];
    }
}
